function historyFlagCountryCode(chat, fallbackCountryCodes = {}) {
  if (!chat || !chat.language) return null;

  const region = String(chat.dialect_code || '')
    .split('-')
    .slice(1)
    .find(subtag => /^[a-z]{2}$/i.test(subtag));

  return (region || fallbackCountryCodes[String(chat.language).toLowerCase()] || '').toLowerCase() || null;
}

function shouldShowLanguageFilter(languages) {
  return Array.isArray(languages) && languages.length >= 2;
}

function buildChatsQuery(page = 1, query = '', language = '') {
  const params = new URLSearchParams({ page });
  if (query) params.set('q', query);
  if (language) params.set('language', language);
  return params.toString();
}

module.exports = { historyFlagCountryCode, shouldShowLanguageFilter, buildChatsQuery };
